module.exports = __webpack_public_path__ + "img/img4.8fc278f6.jpg";